import axios from 'axios'
import _get from 'lodash/get'
import queryString from 'query-string'

import {
    ERROR_MESSAGE_DELETING_FILE,
    ERROR_MESSAGE_DOWNLOADING_FILE,
    FILE_TYPE_TAX_CONSULTATION_CUSTOMER_DOCUMENT,
} from '../constants'
import { reportFileUploadError } from '../helpers/sentry'
import { truncateTextMiddle } from '../helpers/strings'
import { receiveSuccessAlert } from './alerts'
import { handleRequestError } from './request'

export const REQUEST_TAX_CONSULTATION_FILES = 'REQUEST_TAX_CONSULTATION_FILES'
export const RECEIVE_TAX_CONSULTATION_FILES = 'RECEIVE_TAX_CONSULTATION_FILES'
export const REMOVE_TAX_CONSULTATION_FILE = 'REMOVE_TAX_CONSULTATION_FILE'

const UPLOAD_TAX_CONSULTATION_FILE = 'UPLOAD_TAX_CONSULTATION_FILE'
const DOWNLOAD_TAX_CONSULTATION_FILE = 'DOWNLOAD_TAX_CONSULTATION_FILE'
const DELETE_TAX_CONSULTATION_FILE = 'DELETE_TAX_CONSULTATION_FILE'

export const requestTaxConsultationFiles =
    ({ taxConsultationId }) =>
    (dispatch) => {
        dispatch({ type: REQUEST_TAX_CONSULTATION_FILES })

        return axios
            .get(`/taxconsultations/${taxConsultationId}/files`)
            .then((response) => {
                const responseData = _get(response, ['data'], {})
                dispatch(receiveTaxConsultationFiles({ items: responseData, fetchSuccessful: true }))
                return responseData
            })
            .catch((error) => {
                dispatch(handleRequestError(error))
                return Promise.reject(error)
            })
    }

export const uploadTaxConsultationFiles =
    ({ taxConsultationId, files }) =>
    (dispatch) => {
        if (files && files.length) {
            const fileUploadPromises = files.map((file) =>
                dispatch(uploadTaxConsultationFile({ taxConsultationId, file }))
            )
            return Promise.all(fileUploadPromises).then(() =>
                dispatch(requestTaxConsultationFiles({ taxConsultationId }))
            )
        }
        return Promise.resolve()
    }

const uploadTaxConsultationFile =
    ({ taxConsultationId, file }) =>
    (dispatch) => {
        dispatch({ type: UPLOAD_TAX_CONSULTATION_FILE })

        const params = {
            taxConsultationId,
            fileType: FILE_TYPE_TAX_CONSULTATION_CUSTOMER_DOCUMENT,
        }

        const formData = new FormData()
        formData.append('file', file)

        return axios
            .post(`/taxconsultationfiles?${queryString.stringify(params)}`, formData, {
                headers: { 'content-type': 'multipart/form-data' },
            })
            .catch((error) => {
                reportFileUploadError(error, file)
                dispatch(handleRequestError(error))
            })
    }

export const downloadTaxConsultationFile = (data) => (dispatch) => {
    dispatch({ type: DOWNLOAD_TAX_CONSULTATION_FILE })

    const { id } = data

    return axios
        .get(`/taxconsultationfiles/${id}/downloadlink`)
        .then((response) => {
            if (response.data) {
                window.location.assign(response.data)
            }
        })
        .catch((error) => {
            dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DOWNLOADING_FILE }))
        })
}

export const deleteTaxConsultationFile =
    (data, { hideAlert = false } = {}) =>
    (dispatch) => {
        dispatch({ type: DELETE_TAX_CONSULTATION_FILE })

        const { id, fileName } = data

        return axios
            .delete(`/taxconsultationfiles/${id}`)
            .then(() => {
                dispatch(removeTaxConsultationFile({ id }))

                if (!hideAlert) {
                    dispatch(receiveSuccessAlert(`File ${`"${truncateTextMiddle(fileName)}"`} deleted`))
                }
            })
            .catch((error) => {
                dispatch(handleRequestError(error, { customMessage: ERROR_MESSAGE_DELETING_FILE }))
            })
    }

export const removeTaxConsultationFile = ({ id }) => ({ type: REMOVE_TAX_CONSULTATION_FILE, data: { id } })

export const receiveTaxConsultationFiles = (data) => ({ type: RECEIVE_TAX_CONSULTATION_FILES, data })
